'use strict';

const actionRemoveActive = arr =>{

    let elListRemove = document.querySelectorAll(arr);

    if (elListRemove) {
        elListRemove.forEach(el => {
            el.classList.remove('active')
        });
    }
}

const actionTriggerUrl = () =>{

    /* realizando a verificao do parametro da URL ?tab=especiais */
    let elQuery = location.search.slice(1);
    let elParts = elQuery.split('&');

    if (elParts != "") {

    

        elParts.forEach(param => {
            let valueKey = param.split('=');
            let elTabValue = valueKey[1];

            if (elTabValue == 'especiais') {
                /* resetando os modulos de conteudo visiveis */
                actionRemoveActive('.c-podcast-home-tab');
                actionRemoveActive('.c-podcast-home-tabs-nav__link');
                /* resetando os modulos de conteudo visiveis */
                
                let elTab = document.querySelector('.c-podcast-home-tabs-nav__link[data-tab="especials"]');
                let elTabContentSpecial = document.querySelector('.c-podcast-home-tab[data-tab-content="especials"]');

                elTab ? elTab.classList.add('active') : '';
                elTabContentSpecial ? elTabContentSpecial.classList.add('active') : '';
            }

        });
    }
    /* realizando a verificao do parametro da URL ?tab=especiais */

}

export default function() {
	window.addEventListener('DOMContentLoaded', () => {
        actionTriggerUrl();
	});
};
